/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityVulnerabilityResponse {
    getFixupPrototypeFunction() { return SecurityVulnerabilityResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityVulnerabilityResponse>): SecurityVulnerabilityResponse {
        let obj = Object.assign(new SecurityVulnerabilityResponse(), model);
        SecurityVulnerabilityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityVulnerabilityResponse>): SecurityVulnerabilityResponse {
        if (!model) return null;
        return SecurityVulnerabilityResponse.newInstance(<SecurityVulnerabilityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityVulnerabilityResponse) {
        if (!obj) return;

        models.SecurityVulnerabilityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityVulnerabilityResponse): boolean {
        Object.setPrototypeOf(obj, SecurityVulnerabilityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Visibility of the vulnerabilities by findings_type
     */
    findings_type: any;

    /**
     * Visibility of the vulnerabilities by resource_types
     */
    resource_types: any;

    /**
     * Visibility of the vulnerabilities by cloud_accounts
     */
    cloud_accounts: any;

    /**
     * Visibility of the vulnerabilities by count_summary
     */
    count_summary: any;

}
